<template>
  <div :aria-labelledby="id+'-title'"
       :id="id"
       aria-hidden="true"
       class="modal fade"
       role="dialog"
       tabindex="-1">
    
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" :class="{ 'modal-lg': big }"
         role="document">
      <div class="modal-content">
        <div class="modal-header modal-body-scrolled pb-0">
          <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
        </div>
        <div class="modal-body overflow-x-hidden">
          <slot></slot>
        </div>
        <div class="modal-footer flex justify-content-end px-2 shadow-none">
          <button class="btn btn-primary" @click="okCallback" :disabled="processing">
            <spinner small class="text-white" v-if="processing"></spinner>
            {{ okText }}
          </button>
          <button class="btn btn-secondary ml-2" data-dismiss="modal" type="button" v-if="showCancelButton" :disabled="processing">{{cancelButtonText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import { find } from 'lodash'
  import Spinner from '../ui/Spinner.vue'
  
  export default {
    name: 'Modal',
    components: {
      Spinner,
    },
    props: {
      id: {
        default: Math.guid(),
      },
      title: String,
      big: {
        type: Boolean,
        default: false,
      },
      okCallback: {
        type: Function,
        default: () => {
          return new Function()
        },
      },
      okText: {
        type: String,
        default: 'Aceptar',
      },
      showCancelButton: {
        type: Boolean,
        default: false,
      },
      cancelButtonText: {
        type: String,
        default: 'Cerrar'
      },
      processing: false,
    },
    data: () => ({
      name: null,
      loading: false,
    }),
    methods: {
      ...mapActions({
        getResearchLines: 'protocols/getResearchLines',
      }),
      
      clearSearch () {
      
      },
      selected (line) {
        const l = find(this.protocol.research_lines, l => line.id === l.id)
        
        return l !== undefined && l !== null
      },
      async assignLineToProtocol (line) {
      
      },
    },
    computed: {
      ...mapGetters({
        lines: 'protocols/researchLines',
      }),
    },
    async mounted () {
      this.name = this.id
      
      if (this.lines.length === 0) {
        this.loading = true
        
        await this.getResearchLines()
        
        this.loading = false
      }
    },
  }
</script>
